import { FC } from "react";
import { NavLink } from "react-router-dom";
import { Box, HStack, Skeleton } from "@chakra-ui/react";

type AppPageHeaderProps = {
    title: string;
    breadcrumb?: { label: string; url: string }[];
    isLoading?: boolean;
    children?: JSX.Element;
};

export const AppPageHeader: FC<AppPageHeaderProps> = ({
    title,
    breadcrumb,
    isLoading = false,
    children,
}) => {
    return (
        <HStack
            minH={"4.3125rem"}
            px={6}
            borderBottom={"1px solid var(--chakra-colors-primaryT80)"}
            justifyContent={"flex-end"}
            flexWrap={"wrap"}
            gap={0}
        >
            <Box flexGrow={1} mr={6} py={{ base: 3.5, sm: 4, md: "1.125rem" }}>
                {isLoading ? (
                    <Skeleton
                        w="600px"
                        h="29px"
                        startColor="var(--chakra-colors-primaryT95)"
                        endColor="var(--chakra-colors-primaryT80)"
                    />
                ) : (
                    <>
                        {breadcrumb &&
                            breadcrumb.map((item, index) => (
                                <Box as="span" key={index} textStyle="heading4">
                                    <NavLink
                                        to={item.url}
                                        className={"breadcrumb-link"}
                                    >
                                        {item.label}
                                    </NavLink>
                                    &nbsp;
                                    <span
                                        style={{
                                            display: "inline-block",
                                            fontSize: "1.8rem",
                                            transform: "scale(.6, 1)",
                                            color: "var(--chakra-colors-primaryT50)",
                                        }}
                                    >
                                        &gt;
                                    </span>
                                    &nbsp;
                                </Box>
                            ))}
                        <Box as="span" textStyle="heading4">
                            {!isLoading && title}
                        </Box>
                    </>
                )}
            </Box>
            {children}
        </HStack>
    );
};
